<template>
    <div class="doc-section">
        <h1>Alertas</h1>
        <p>
            El sistema centraliza los eventos críticos reportados por los dispositivos en los últimos 30 días,
            permitiendo una respuesta rápida ante incidencias operativas.
        </p>

        <h2>Acceso al Listado</h2>
        <ol class="ul-contenedor">
            <li>Diríjase al menú principal y seleccione la opción <strong>Monitoreo</strong>.</li>
            <li>Haga clic sobre el botón <strong>Listado de alertas</strong>.</li>
            <li>Se mostrará la pantalla principal con el histórico de notificaciones recientes.</li>
        </ol>

        <div class="info-card">
            <p><strong>Restricciones de visibilidad:</strong></p>
            <ul class="ul-contenedor step-list">
                <li>a) El <strong>Administrador</strong> puede visualizar la totalidad de las alertas globales.</li>
                <li>b) El <strong>Usuario final</strong> solo visualiza alertas de las unidades que tiene vinculadas.
                </li>
            </ul>
        </div>

        <h2>Interacción con Alertas</h2>
        <p>Todas las alertas, sin importar su tipo, permiten la localización geográfica mediante los siguientes
            controles:</p>

        <ol class="ul-contenedor step-list">
            <li><strong>Ver (Icono Ojo):</strong> Proyecta en el mapa el marcador exacto donde se originó el evento,
                mostrando una ventana con detalles de velocidad, batería y coordenadas.</li>
            <li><strong>Ocultar (Icono Ojo tachado):</strong> Remueve el marcador del mapa para limpiar la vista de
                monitoreo.</li>
        </ol>

        <h2>Catálogo de Tipos de Alerta</h2>
        <p>A continuación se describen los identificadores visuales y condiciones de activación para cada categoría:</p>


        <h3>Guía de Identificación de Alertas</h3>
        <CarruselAciqui :items="itemsAlertas" />

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';

export default {
    name: 'AlertasSistema',
    components: { CarruselAciqui },
    data: () => ({
        itemsAlertas: [
            {
                nombre: "Batería Baja",
                url: "img/Alertas/bateriaBaja.png",
                descripcion: "Círculo Naranja. Se activa al detectar 25% de energía o menos. Muestra porcentaje de carga y ubicación."
            },
            {
                nombre: "Impacto",
                url: "img/Alertas/impacto.png",
                descripcion: "Círculo Rojo (Icono Explosión). Se detona al detectar colisiones o golpes fuertes según la sensibilidad configurada."
            },
            {
                nombre: "Movimiento",
                url: "img/Alertas/movimiento.png",
                descripcion: "Círculo Verde. Notifica cuando el dispositivo inicia desplazamiento tras haber estado en estado estático."
            },
            {
                nombre: "Velocidad",
                url: "img/Alertas/velocidad.png",
                descripcion: "Círculo Azul (Icono Velocímetro). Se activa cuando la unidad excede el límite de velocidad establecido en la configuración."
            },
            {
                nombre: "Geocerca",
                url: "img/Alertas/geocerca.png",
                descripcion: "Círculo Morado (Icono Diana). Reporta entradas o salidas de perímetros virtuales, indicando el nombre de la geocerca afectada."
            }
        ]
    })
}
</script>